import * as React from "react"
import { t } from "ttag"

import { ErroredMetricsCard } from "@humanpredictiveintelligence/myqvt-library"
import { BaseProps } from "@humanpredictiveintelligence/myqvt-library"

export const ErroredGlobalFeedbacksMetrics: React.FC<BaseProps> = (props) => (
  <div className={props.className}>
    <ErroredMetricsCard hasReducedPadding title={t`Global feedbacks`}>
      {t`An error has occurred.`}
    </ErroredMetricsCard>
  </div>
)
